import React, {useEffect, useState} from "react";
import backicon from "../image/backicon.svg";
import {useNavigate, useParams} from "react-router-dom";
import {useContext} from "react";
import {UseContext} from "../context";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import {MapComponent, MapTypes} from "@neshan-maps-platform/mapbox-gl-react";
import "@neshan-maps-platform/mapbox-gl-react/dist/style.css";
import "./Scroll.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import desimg from "../image/destination.svg";
import beginningimg from "../image/beginning.svg";
import axios from "axios";
import {url} from "../url";
import Loadingcom from "./allcomponent/Loading";
import '@neshan-maps-platform/mapbox-gl/dist/NeshanMapboxGl.css';


const Everyhistravelcard = () => {

    const travel = useParams()


    const navigate = useNavigate();

    // const data = location.state;

    const [data, setData] = useState({})

    const [loading, setLoading] = useState(true);

    const {setShowhis, setShowhistrinprogress} = useContext(UseContext);
    const handlecloseeveryhiscom = () => {
        navigate("/history");
        setShowhis(true);
        setShowhistrinprogress(false);
    };

    useEffect(() => {
        setLoading(true)
        axios
            .get(`${url}/travel/v1/get-single-travel-driver/${travel.id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                setLoading(false)
                setData(res.data.data)
            })
            .catch((error) => {
                setLoading(true)
                // if (error.response) {
                //     setActiveloading(false)
                //     if (error?.response?.status === 404) {
                //         setNoActiveTravel(true)
                //     } else {
                //         setErroractivet(error?.response?.data?.message);
                //         setActiveloading(true)
                //     }
                // }
                //
                // if (error?.message === "Network Error") setActiveloading(true);
            });


    }, [travel.id]);

    useEffect(() => {
        if (data !== null && data.location) {
            console.log(data.location)
            const Map = new nmp_mapboxgl.Map({
                mapType: nmp_mapboxgl.Map.mapTypes.neshanVector,
                container: "map",
                zoom: 7,
                pitch: 0,
                center: [data.location?.longitude, data.location?.latitude],
                minZoom: 2,
                maxZoom: 21,
                trackResize: true,
                mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                poi: true,
                traffic: false,
                isZoomControlsEnabled: true,
                setZoomGesturesEnabled: true,
                mapTypeControllerOptions: {
                    show: false,
                },
            });
            Map?.addControl(new nmp_mapboxgl.NavigationControl(), "top-right");
            new nmp_mapboxgl.Marker()
                .setLngLat([data.location?.longitude, data.location?.latitude])
                .addTo(Map);
        }
    }, [data]);

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {!loading ?
                        data !== null ? (
                            <>
                                <div
                                    className="w-full h-full overflow-auto  flex-row"
                                    id="activescrollbar"
                                >
                                    <div className="row-span-1 mt-3 mr-4 ">
                                        <img
                                            alt=""
                                            onClick={handlecloseeveryhiscom}
                                            className="cursor-pointer"
                                            src={backicon}
                                        ></img>
                                    </div>
                                    {data.location ? (
                                        <>
                                            <div className="row-span-1 mt-4 mx-4  ">
                                                <div className="w-full h-[300px]">
                                                    <MapComponent
                                                        id="map"
                                                        options={{
                                                            mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                                                            mapType: MapTypes.neshanVector,
                                                            mapTypeControllerOptions: {
                                                                show: false,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className="row-span-1 mt-8">
                                                    <div
                                                        className="border-[1px]  h-[1px] border-[rgba(0, 0, 0, 0.2)] "></div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}

                                    <div className='grid grid-cols-3 mt-7'>
                                        <div
                                            className='col-span-1 border-l-2 items-center border-[rgba(0, 0, 0, 0.2)]'>
                                            <div
                                                className="flex flex-col h-full justify-center items-center gap-2 ">
                                                <div className="mr-4 text-[14px]">
                                                    <DatePicker
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        value={data.travel_date}
                                                        readOnly
                                                        style={{
                                                            backgroundColor: "transparent",
                                                            outline: "none",
                                                            border: "none",
                                                            width: "100px",
                                                            marginTop: "-6px",
                                                            fontSize: "16px",
                                                            marginLeft: "-12px",
                                                        }}
                                                    />
                                                </div>

                                                <div>
                                                    <p className="mr-5 text-[14px]"> {data.travel_hour_time} </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-span-2">

                                            <div className="flex flex-col justify-center h-full gap-4">
                                                <div className="row-span-1 flex gap-2 w-full text-[14px]">
                                                    <img
                                                        alt=""
                                                        src={desimg}
                                                        className="h-[18px] w-[12px]  mt-4  mr-4"
                                                    ></img>
                                                    <p className="mt-3"> {data.destination_city?.name}</p>
                                                </div>
                                                <div className="row-span-1  flex w-full">
                                                    <img
                                                        alt=""
                                                        src={beginningimg}
                                                        className="h-[18px] w-[12px] mr-4"
                                                    ></img>

                                                    <div className="pt-1 px-2 flex flex-wrap text-[14px]">
                                                        <p className="">
                                                            {data.origin_city?.name}
                                                        </p>
                                                        <p className="">
                                                            {data.address && <>, {data.address}</>}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>

                                    <div className="row-span-1 mt-4">
                                        <div
                                            className="border-[1px] mr-4 ml-4 h-[1px] border-[rgba(0, 0, 0, 0.2)] "></div>
                                    </div>

                                    <div className='col-span-1 mt-4 mx-5 flex flex-col '>

                                        <div className='flex gap-2'>
                                            <p className=" flex justify-start items-center text-[14px] font-medium ">
                                                وضعیت سفر :
                                            </p>
                                            <div className=" flex font-medium gap-1 text-pricetxcolor">
                                                {data.status === "active" &&
                                                    <span className="text-bluetext flex gap-1">
                                                    فعال
                                                </span>}
                                                {data.status === "completed" &&
                                                    <span className="text-greentext flex gap-1">
                                                    انجام شده
                                                </span>}
                                                {data.status === "canceled" &&
                                                    <span className="text-detailcolor flex gap-1">
                                                    لغو شده
                                                </span>}
                                            </div>

                                        </div>

                                        <div className="flex gap-2">
                                            <p className=" flex justify-start items-center text-[14px] font-medium ">
                                                قیمت دریافت شده :
                                            </p>
                                            <div className=" flex font-medium gap-1 text-pricetxcolor">
                                                        <span
                                                            className="mt-1 text-black text-pricetxcolor text-[14px]">{data.price - (data.price_paid ?? 0)}</span>
                                                <span className="mt-[2px] text-black text-[14px]">تومان</span>
                                            </div>

                                        </div>


                                    </div>


                                    <div className="row-span-1 mt-4">
                                        <div
                                            className="border-[1px] mr-4 ml-4 h-[1px] border-[rgba(0, 0, 0, 0.2)] "></div>
                                    </div>


                                    <div className="flex-col flex gap-3 mr-6 mt-4">


                                        <div className="flex gap-2 ">
                                            <p className="">نام مسافر :</p>
                                            <p className="">
                                                {data?.passenger_snapshot?.full_name}
                                            </p>
                                        </div>

                                        <div className="flex gap-2">
                                            <p className="">تعداد مسافر :</p>
                                            <p className=" ">{data?.passenger_count} نفر</p>
                                        </div>

                                        <div className="flex gap-2 ">
                                            <p className=" ">
                                                شماره تماس مسافر :
                                            </p>
                                            <p className="">
                                                0{data.passenger_snapshot?.mobile}
                                            </p>
                                        </div>


                                    </div>
                                </div>
                            </>
                        ) : (
                            navigate("/history")
                        )
                        :
                        (<div
                            className="h-full flex items-center justify-center">

                            <div className="mt-4">
                                <Loadingcom/>
                            </div>
                        </div>)
                    }
                </>
            ) : (
                navigate("/")
            )}
        </>
    );
};
export default Everyhistravelcard;
